"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createOldSlateNode = exports.createSlateNode = void 0;
exports.createSlateNode = (text, type) => {
    return {
        type,
        children: [
            {
                text,
            },
        ],
    };
};
exports.createOldSlateNode = (text, type) => {
    return {
        object: "block",
        type: type,
        nodes: [{ object: "text", text: text || "" }],
    };
};
//# sourceMappingURL=createSlateNode.js.map